var React = require('react');
var Pumper = require('../_common/Pumper');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');

var familyPump = require('../../../flux/familyPump');

var FamilyPump = React.createClass({

    propTypes: {
        backgroundKey: React.PropTypes.string,
        movieclipKeys: React.PropTypes.array,
        fluxSettings: React.PropTypes.object
    },

    getDefaultProps: function()
    {
        return {
            className: 'family-pump',
            backgroundKey: 'familyPumpBg',
            movieclipKeys: ['mom', 'pumperDad'],
            pumperKey: 'pumperDad',
            pumpKey: 'dadPump',
            fluxSettings: familyPump,

        };
    },

    render: function ()
    {
        return (
            <Pumper
                title={'sophia_jamal'}
                role={'sophia_jamal_title'}
                onAfterObjectsBuild={this.onAfterObjectsBuild}
                {...this.props}
                hasGuillotine
            />
        );
    },

    onAfterObjectsBuild: function (container, timeline) {
        const props = this.props;
        const objs = props.objs;

        const momLandauObject = objs.momLandau;
        const momLandau = createSprite(momLandauObject);
        momLandau.userData = { character: true };
        Utils.setSizeAndPositionFromRefSize(momLandau, props.width, props.height, momLandauObject);
        container.addChildAt(momLandau, 0);
    }
});

module.exports = FamilyPump;



// WEBPACK FOOTER //
// ./js/components/frames/A-Remuneration/3-FamilyPump.jsx